import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { useSetSidepanelHeaderHeight } from '../../../atoms'
import { useElementHeightObserver } from '../../../hooks/use-element-height-observer'

type SidepanelHeaderProps = ComponentProps<'div'>

// Static top bar of the unified panel surface — a normal flex child, so it
// shares the surface's translucency (no stacked background) and the body
// scrolls in the region below it rather than beneath it. Height is still
// observed for consumers that position relative to it (the view router).
export function SidepanelHeader({ children, className, ...props }: SidepanelHeaderProps) {
  const setHeaderHeight = useSetSidepanelHeaderHeight()
  const headerRef = useElementHeightObserver(setHeaderHeight, {
    observe: true,
  })

  return (
    <div
      ref={headerRef}
      className={twMerge('pointer-events-auto relative z-10 flex w-full shrink-0 items-center', className)}
      {...props}
    >
      <div className="relative w-full">{children}</div>
    </div>
  )
}
